import api from '@/modules/api'
import { AxiosResponse } from 'axios'
import { IApiResponse } from '@/common/models/interface'
import { warningNotify } from '@/modules/notify'
import { i18n } from '@/plugins/i18n'


export default class AuthService {
  /**
   * Login
   *
   * @param {any} payload
   * @returns {Promise<any>}
   * @memberof AuthService
   */
  public async login(payload: any): Promise<IApiResponse<any>> {
    const res: AxiosResponse<any> = await api.post('Auth/Login', payload)
    return res.data
  }

  /**
   * Logout
   *
   * @returns {Promise<any>}
   * @memberof AuthService
   */
  public async logout(): Promise<any> {
    const res: AxiosResponse<any> = await api.post('Auth/Logout')
    return res.data
  }

  /**
   * Refresh token and get new tokens
   *
   * @param {any} payload
   * @returns {Promise<any>}
   * @memberof AuthService
   */
  public async refreshToken(refreshToken: string): Promise<any> {
    const payload = {
      'refreshToken': refreshToken,
    }
    const _t: any = i18n.global

    try{ 
      const res: AxiosResponse<any> = await api.post('Auth/RefreshToken', payload)
      return res.data
    }
    catch (err) {
      warningNotify(_t.tc('common.error.httpRefreshTokenError'))
      throw err
    }
  }
}
